<template>
  <div class="flex gap-4" :class="[{ col: labeled, 'bg wrap': bg }, size]">
    <template v-for="(link, key) in $branch.socialLinks">
      <div class="link">
        <a
          v-if="link"
          :href="link"
          :key="key"
          :aria-label="key"
          target="_blank"
          :class="['plain', { 'text-primary': primary, 'bg-tertiary': bg }]"
        >
          <AppIcon :icon="ICONS[key]" :start="labeled" />
          <span v-if="labeled">{{ $tt(`socials.${key}`) }}</span>
        </a>
        <InfoIconTooltip v-if="isFbSocial(key) && $branch.fbBanMsg" color="#bbb" class="tooltip" :class="{ labeled }">
          {{ $branch.fbBanMsg }}
        </InfoIconTooltip>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { SocialMedia } from '~/types';

defineProps<{
  labeled?: boolean;
  size?: 'small' | 'medium' | 'large';
  primary?: boolean;
  bg?: boolean;
}>();

const ICONS: Record<SocialMedia, string> = {
  facebook: 'circum:facebook',
  instagram: 'mdi:instagram',
  google: 'mdi:google',
  x: 'akar-icons:x-fill',
  vk: 'uil:vk-alt',
  yandex: 'la:yandex-international'
};

function isFbSocial(social: SocialMedia) {
  return social == 'facebook' || social == 'instagram';
}
</script>

<style scoped>
.link {
  position: relative;
}
.tooltip {
  position: absolute;
  top: calc(-1 * var(--space-5));
  left: var(--space-3);
}
.tooltip.labeled {
  left: unset;
}
.medium {
  font-size: 22px;
}
.medium .tooltip {
  top: calc(-1 * var(--space-5));
  left: var(--space-4);
}
.large {
  font-size: 30px;
  justify-content: center;
  flex-wrap: wrap;
}
.large .tooltip {
  top: calc(-1 * var(--space-5));
  left: var(--space-5);
}
.bg .tooltip {
  left: var(--space-7) !important;
}
</style>